module.exports = __webpack_public_path__ + "img/levelvertRight.75637982.svg";